import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/styleguide.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';

if (process.env.NODE_ENV === 'development') {
  // Suppress noisy browser-only ResizeObserver loop warnings in CRA overlay.
  const resizeObserverOverlayFilter = (event) => {
    const message = event?.message || event?.reason?.message;

    if (
      typeof message === 'string' &&
      (message.includes('ResizeObserver loop completed with undelivered notifications') ||
        message.includes('ResizeObserver loop limit exceeded'))
    ) {
      event.stopImmediatePropagation();
    }
  };

  window.addEventListener('error', resizeObserverOverlayFilter);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}
  >
    <App />
  </BrowserRouter>
);
